import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlservico = '/service/portal/conteudo/transparencia/busca/'

class BuscarPesquisaService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    getPesquisar(conteudo) {
        let data = {
            criterio: conteudo,
        }
        return this.conex.post(urlservico, JSON.stringify(data))
    }
}

export default BuscarPesquisaService
